import { Paper } from '@mui/material';
import { styled } from 'styled-components';

export const TagsStyled = styled(Paper)`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export default TagsStyled;
